import { Box, Typography } from "@mui/material";
import "./pharma.css";
import Grid from "@mui/material/Unstable_Grid2";

//Carousel
import Carousel from "react-bootstrap/Carousel";

//logo
import logo1 from "./assete/Pharma/logo1.png";
import logo2 from "./assete/Pharma/logo2.png";
import logo3 from "./assete/Pharma/logo3.png";
import logo4 from "./assete/Pharma/logo4.png";
import logo5 from "./assete/Pharma/logo5.png";
//photo
import pic1 from "./assete/Pharma/pic1.png";
import pic2 from "./assete/Pharma/pic2.png";
import pic3 from "./assete/Pharma/pic3.png";
import pic4 from "./assete/Pharma/pic4.png";
import pic5 from "./assete/Pharma/pic5.png";
import pic6 from "./assete/Pharma/pic6.png";

const Pharma = () => {
  return (
    <>
      <Grid container>
        <Grid xl={12}>
          <Box
            component="div"
            className="logo"
            sx={{
              display: "flex",

              justifyContent: "space-between",
              margin: "20px 0px",
            }}
          >
            <img src={logo1} alt="Logo" style={{ width: "10%" }}></img>
            <img src={logo2} alt="Logo" style={{ width: "10%" }}></img>
            <img src={logo3} alt="Logo" style={{ width: "10%" }}></img>
            <img src={logo4} alt="Logo" style={{ width: "10%" }}></img>
            <img src={logo5} alt="Logo" style={{ width: "10%" }}></img>
          </Box>
        </Grid>
        <Grid xs={12} sm={12} md={6} lg={6}>
          <Box component="div" className="text" sx={{ marginTop: "20px" }}>
            <Typography variant="h5" sx={{ fontFamily: "Homa" }}>
              به روزرسانی سیستم ابزار دقیق و کنترل
            </Typography>
            <ul
              style={{
                fontFamily: "Homa",
                marginTop: "15px",
                fontSize: "1.15rem",
              }}
            >
              <li>واحد آب سازی کارخانه ی داروسازی دانا</li>
              <li>واحد آب سازی کارخانه داروسازی زهراوی</li>
            </ul>
            <Typography variant="h5" sx={{ fontFamily: "Homa" }}>
              سیستم مانیتورینگ ، ثبت اطلاعات و هشدار پارامتر ها
            </Typography>
            <ul
              style={{
                fontFamily: "Homa",
                marginTop: "15px",
                fontSize: "1.15rem",
              }}
            >
              <li>انبار های مواد اولیه ، بسته بندی و تولید داروسازی زهراوی</li>
            </ul>
            <Typography variant="h5" sx={{ fontFamily: "Homa" }}>
              اندازه گیری دبی عبوری و کنترل بچینگ
            </Typography>
            <ul
              style={{
                fontFamily: "Homa",
                marginTop: "15px",
                fontSize: "1.15rem",
              }}
            >
              <li>واحد حلال های داروسازی دانا</li>
              <li>واحد حلال های داروسازی شهید قاضی</li>
            </ul>
            <Typography variant="h5" sx={{ fontFamily: "Homa" }}>
              اجرای سیستم کنترل و مانیتورینگ
            </Typography>
            <ul
              style={{
                fontFamily: "Homa",
                marginTop: "15px",
                fontSize: "1.15rem",
              }}
            >
              <li>خطوط تولید پودر و مایع لباسشویی کارخانه یونیلیور</li>
            </ul>
            <Typography variant="h5" sx={{ fontFamily: "Homa" }}>
              به روزرسانی و تعویض سیستم کنترل ، مانیتورینگ و هشدار
            </Typography>
            <ul
              style={{
                fontFamily: "Homa",
                marginTop: "15px",
                fontSize: "1.15rem",
              }}
            >
              <li>
                خط{" "}
                <span style={{ fontFamily: "roboto", fontSize: "1rem" }}>
                  B
                </span>{" "}
                الکترولایزرهای کارخانه کلرپارس
              </li>
              <li>خط تولید سیکلوسپورین و سل سپت داروسازی زهراوی</li>
            </ul>
          </Box>
        </Grid>
        <Grid xs={12} sm={12} md={6} lg={6}>
          <Box component="div" sx={{ marginTop: "20px" }}>
            <Carousel style={{ width: "100%", float: "left" }}>
              <Carousel.Item>
                <img src={pic2} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic1} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic3} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic4} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic5} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
              <Carousel.Item>
                <img src={pic6} alt="Pictures" style={{ width: "100%" }}></img>
              </Carousel.Item>
            </Carousel>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};
export default Pharma;
